import http from "./http";

export async function fetchYoutubeVideos() {
  const response = await http.get("/utils/youtube-videos");
  const data = response?.data?.data;
  return Array.isArray(data) ? data : [];
}
